<template>
  <div>
    <section class="user-info text-center">
      <div class="avator">
        <img
          :src="
            'https://oss-us-cdn.maiziqianbao.net/Chain_logo/' + chainInfo.logo
          "
          width="100%"
        />
      </div>
      <h4>{{ webUtil.stringToCapitalize(selectedChain) }} Wallet</h4>
      <p id="copyContent">{{ account }}</p>
      <div class="operation-list">
        <!-- 复制地址 -->
        <a class="blue-btn" @click="copyAddress(account)">
          {{ $t("webwallet_copy_address") }}
        </a>
        <a
          class="blue-btn"
          target="_blank"
          :href="chainInfo.explorerUrl.replace('{$addr}', account)"
        >
          {{ $t("blockchain_explorer") }}
        </a>
      </div>
      <div class="token-info">
        <!-- 总计 -->
        <p>{{ $t("webwallet_total") }} {{ symbol }}</p>
        <h4>{{ webUtil.addCommas(balancesSum, 6) }}</h4>
        <p class="grey-fsz">
          &#8776;
          {{ webUtil.addCommas(balancesValue ? balancesValue : "0.00") }}
          {{ unit }}
        </p>
        <ul class="token-list">
          <li v-for="(item, index) in tokensInfoList" :key="index">
            <div>{{ item.symbol }}</div>
            <div>{{ item.balance ? item.balance : 0 }}</div>
          </li>
        </ul>
      </div>
      <a class="blue-btn" target="_blank" @click="termsShow = true">
        {{ $t("add_custom_token") }}
      </a>
    </section>
    <div class="refresh-logout">
      <!-- 刷新 -->
      <a class="grey-fsz refresh" @click="refresh">{{
        $t("webwallet_refresh")
      }}</a>
      <!-- 退出 -->
      <a class="grey-fsz logout" @click="logout">{{
        $t("webwallet_logout")
      }}</a>
    </div>
    <main class="modal basic-form" v-if="termsShow">
      <div class="modal-content">
        <h3>{{ $t("add_custom_token") }}</h3>
        <label>{{ $t("token_address") }}</label>
        <input
          type="text"
          :placeholder="$t('token_address')"
          v-model="customTokenAddress"
          @input="dbSymbolDecimals"
        />
        <label>{{ $t("token_decimals") }}</label>
        <input type="text" v-model="customTokenDecimals" readonly />
        <label>{{ $t("token_symbol") }}</label>
        <input type="text" v-model="customTokenSymbol" readonly />
        <p class="text-right">
          <button
            class="modal-btn modal-cancel-btn"
            @click.stop="termsShow = false"
          >
            {{ $t("cancel_btn") }}
          </button>
          <button class="modal-btn modal-add-btn" @click="addToken">
            {{ $t("add") }}
          </button>
        </p>
      </div>
    </main>
  </div>
</template>
<script>
import lodash from "lodash";
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      termsShow: false,
      balancesSum: "",
      customTokenAddress: "",
      customTokenSymbol: "",
      customTokenDecimals: "",
    };
  },
  computed: {
    ...mapGetters({
      tokensInfoList: "tokensInfoList",
    }),
    balancesValue() {
      let value =
        this.legalCoin && this.legalCoin.rmb
          ? new this.BigNumber(this.balancesSum)
              .times(this.price)
              .div(this.legalCoin.rmb)
              .toFixed(8, 1)
          : 0;
      return value;
    },
  },
  watch: {
    account(to) {
      if (to) {
        this.initExtension();
      }
    },
  },
  created() {
    this.dbSymbolDecimals = lodash.debounce(this.getTokenSymbolDecimals, 500);
    if (this.account) {
      this.initExtension();
    }
  },
  methods: {
    ...mapActions(["setTokensInfoList"]),
    refresh() {
      window.location.reload();
    },
    logout() {
      sessionStorage.clear();
      window.location.reload();
    },
    async initExtension() {
      this.balancesSum = 0;
      // 获取主token余额
      let mainBalance = await this.getMainBalance();
      let sum = new this.BigNumber(this.balancesSum)
        .plus(mainBalance)
        .toFixed(4, 3);
      this.balancesSum = sum;
      await this.getAccountTokenBalance();
      // 排序
      this.tokensInfoList.sort(this.compare());
      this.setTokensInfoList(this.tokensInfoList);
    },
    // 获取账号下的tokens
    async getAccountTokens() {
      let url =
        "https://a5.maiziqianbao.net/api/v1.1/tokens/" +
        this.chainInfo.chainType +
        "/" +
        this.chainInfo.chainID +
        "/account/";
      return await this.axios.get(url + this.account).then((response) => {
        if (
          response &&
          response.data &&
          response.data.data &&
          response.data.data.tokens
        ) {
          return response.data.data.tokens;
        }
      });
    },
    //获取token的余额
    async getAccountTokenBalance() {
      // let list = [];
      let tokens = await this.getAccountTokens();
      if (tokens && tokens.length > 0) {
        for (let token of tokens) {
          let balance = "0";
          balance = await this.user?.getTokenBalance({
            from: this.account,
            to: token.address,
          });
          balance = this.webUtil.formatBalance(balance, token.decimals);
          if (balance - 0 > 0) {
            let info = {
              address: token.address,
              symbol: token.symbol,
              decimals: token.decimals,
              balance: balance - 0,
              price: parseFloat(token.price),
            };
            let findListToken = this.tokensInfoList.filter((item) => {
              return item.address == token.address;
            });
            if (findListToken.length <= 0) {
              this.setTokensInfoList([...this.tokensInfoList, info]);
              // 计算换算成主token
              if (this.price > 0) {
                let balancesSum = new this.BigNumber(token.price)
                  .times(balance)
                  .div(this.price)
                  .plus(this.balancesSum)
                  .toFixed(4, 3);
                this.balancesSum = balancesSum;
              }
            }
          }
        }
        this.coinChange(this.unit);
        return this.tokensInfoList;
      }
    },
    // 主token
    async getMainBalance() {
      let mainBalance = await this.user?.getBalance(this.account);
      mainBalance = new this.BigNumber(mainBalance).toFixed(4, 3);
      this.setTokensInfoList([
        // ...this.tokensInfoList,
        {
          address: "",
          symbol: this.symbol,
          decimals: this.decimal,
          balance: mainBalance,
          price: this.price,
        },
      ]);
      return mainBalance;
    },
    compare() {
      return function (a, b) {
        if (b.symbol > a.symbol) {
          return -1;
        } else if (a.symbol > b.symbol) {
          return 1;
        }
        return 0;
      };
    },
    initCustomData() {
      this.customTokenDecimals = "";
      this.customTokenSymbol = "";
      this.customTokenAddress = "";
    },
    // 根据合约地址获取精度和symbol
    async getTokenSymbolDecimals() {
      this.customTokenDecimals = "";
      this.customTokenSymbol = "";
      this.customTokenAddress = this.customTokenAddress.trim();
      if (this.customTokenAddress) {
        if (!this.user?.isAddress(this.customTokenAddress)) {
          return this.$alert(this.$t("invalid_address"));
        }
        // 判断当前列表是否存在该token
        let token = this.tokensInfoList.filter((item) => {
          return item.address == this.customTokenAddress;
        });
        if (token.length > 0) {
          return this.$alert(this.$t("token_exist"));
        }
        try {
          let decimalsHex = await this.user.call({
            data: "0x313ce567000000000000000000000000",
            to: this.customTokenAddress,
          });
          let symbolHex = await this.user.call({
            data: "0x95d89b41000000000000000000000000",
            to: this.customTokenAddress,
          });
          if (decimalsHex && decimalsHex == "0x") {
            return this.$alert(this.$t("invalid_address"));
          } else {
            this.customTokenDecimals = decimalsHex - 0;
          }
          let tmp = this.webUtil.rightZerosStrip("0x" + symbolHex.substr(-64));
          this.customTokenSymbol = this.webUtil.hex2str(tmp);
        } catch (e) {}
      }
    },
    // 自定义添加token
    async addToken() {
      if (
        this.customTokenAddress &&
        this.customTokenDecimals >= 0 &&
        this.customTokenSymbol
      ) {
        // 获取余额
        let balance = await this.user?.getTokenBalance({
          from: this.account,
          to: this.customTokenAddress,
        });
        balance = this.webUtil.formatBalance(balance, this.customTokenDecimals);
        let detail = {
          address: this.customTokenAddress,
          symbol: this.customTokenSymbol,
          decimals: this.customTokenDecimals,
          balance: balance - 0,
          price: 0,
        };

        let tmp = JSON.parse(sessionStorage.getItem("addedTokenList"))
          ? JSON.parse(sessionStorage.getItem("addedTokenList"))
          : [];
        let findSessionToken = tmp.filter((item) => {
          return item.address == this.customTokenAddress;
        });
        if (findSessionToken.length <= 0) {
          tmp.push(detail);
          sessionStorage.setItem("addedTokenList", JSON.stringify(tmp));
        }

        // 在加入tokenInfoList之前检查是否已存在
        let findListToken = this.tokensInfoList.filter((item) => {
          return item.address == this.customTokenAddress;
        });
        if (findListToken.length <= 0) {
          this.tokensInfoList.push(detail);
          this.tokensInfoList.sort(this.compare());
          this.setTokensInfoList(this.tokensInfoList);
        }
        this.initCustomData();
        this.termsShow = false;
      }
    },
  },
};
</script>
<style scoped>
.blue-btn {
  display: block;
}
</style>
